import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const dialogId = event.params?.dialogId
    if (!dialogId) return

    const dialog = document.getElementById(dialogId)
    if (dialog && !dialog.open) dialog.showModal()
  }

  close(event) {
    event.preventDefault()
    event.target?.closest("dialog")?.close()
  }

  closeFromBackdrop(event) {
    if (event.target === event.currentTarget && typeof event.currentTarget.close === "function") {
      event.currentTarget.close()
    }
  }
}
